import { render, staticRenderFns } from "./RegistrationDepositReport.container.vue?vue&type=template&id=901942ea&scoped=true&"
import script from "./RegistrationDepositReport.container.vue?vue&type=script&lang=js&"
export * from "./RegistrationDepositReport.container.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDepositReport.container.vue?vue&type=style&index=0&id=901942ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901942ea",
  null
  
)

export default component.exports